import { logsConstants } from '../../../locale/logs'

export const COMPLETED_BY_KEYS: Record<string, string> = {
  he: logsConstants.COMPLETED_BY_HIMSELF,
  she: logsConstants.COMPLETED_BY_HERSELF,
  they: logsConstants.COMPLETED_BY_THEMSELF
}
